import { TableColumn } from '../models';

/**
 * Retrieves the width of a specific column based on its identifier.
 *
 * @param colDefs - Array of TableColumn definitions.
 * @param id - Identifier of the column for which width is needed.
 * @returns The width of the column if found; otherwise, a default width of "100px".
 */
export const getColumnWidth = (colDefs: TableColumn[], id: string): string | undefined => {
  // Search for the column definition that matches the provided id
  const colDef = colDefs?.find(col => col.field === id);

  // If a matching column definition is found, return its width; otherwise, return the default width
  return colDef ? colDef.width : '100px';
};
